import { PartTypeSchema, PartTypeType } from "../types";

type Params = {
  partType: PartTypeType | undefined | null;
};

export const isMachiningDimensions = ({ partType }: Params) => {
  switch (partType) {
    case PartTypeSchema.enum.MACHINING:
      return true;
    default:
      return false;
  }
};
